import React from "react"
import "./Project.css"
import ProjectCard from "./ProjectCard"
import ProjectCard2 from "./ProjectCard2"
import malarAiImagePath from "./img/malar_ai.jpeg"
import smartDustinImagePath from "./img/smart_dustbin.jpeg"
import augnexImagePath from "./img/augnex.jpeg"
import aquilaImagePath from "./img/aquila.jpeg"
import digitWellImagePath from "./img/digi_well.jpeg"
import exoSkeletonImagePath from "./img/exo_skeleton.jpg"
import safeHerImagePath from "./img/safe_her.jpeg"
import streetWiseImagePath from "./img/street_wise.jpeg"

function Project() {
  return (
    <div className="ProjectApp">
      <div className="project-data project-animation project-box project-glowing">
        <p>
          CSI's Innovative projects have solved 30+ life-changing problems
          across the fields of Aerotech, defence, medical, smart living, space
          research, and many such. Our CSI started with solving the garbage
          problem and successfully designed an electric-assist vehicle. A
          glimpse of our outstanding projects: - Malar-AI, Cataract Detection,
          Smart Dustbin, and Electric Assist Pedal Vehicle
        </p>
      </div>

      <h1 className="project-heading">Our Projects</h1>

      <div className="container_balls">
        <ul>
          <li />
          <li />
          <li />
          <li />
          <li />
        </ul>
      </div>

      <div className="all-cards">
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          content="Malar-AI is a handy device detect probable malaria infection using blood smear slides. Powered by ResNet-50, cell-phone microscope and a staining kit, this setup is capable of performing at an accuracy of >95%. Enhances the ease of Malaria testing in areas where the availability of testing equipments is not adequate."
          imgUrl={malarAiImagePath}
          name="Malar-AI"
          showKnowMore="true"
        />
        <ProjectCard2
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-left"}
          animType2="flip-left"
          content="Smart Dustbin : Incentivization of garbage disposal by providing discount coupons for throwing waste in Dustbins. Also provides the real-time bin fill status to prevent overflowing of garbage."
          imgUrl={smartDustinImagePath}
          name="Smart Dustbin"
          showKnowMore="true"
        />
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          content="Augnex is an AR-based(Augmented Reality) web application. This project aims to enhance the navigational experience in the campus
          by integrating Augmented Reality with maps. It enable new people to find places and venues in campus."
          imgUrl={augnexImagePath}
          name="Augnex"
          showKnowMore="true"
        />
        <ProjectCard2
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-left"}
          animType2="flip-left"
          content="Exoskeleton Focuses on building a suite that is cost effective.Increases strength of a body to give
         support to muscle. With the help of this exoskeleton person with disabilities can work easily without any difficulties. Helpful in performing various vigorous  tasks with ease."
          imgUrl={exoSkeletonImagePath}
          name="Exoskeleton"
          showKnowMore="true"
        />
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          content="Aquila : This Project has APM Drone which is capable of adsorbing dust and particulate matter,
         thereby decrease particulate matters into atmosphere. APM Drone will autonomously driven by solar power, also structurally similar to RC plane."
          imgUrl={aquilaImagePath}
          name="Aquila"
          showKnowMore="true"
        />
        <ProjectCard2
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-left"}
          animType2="flip-left"
          name="Digiwell"
          content="Digiwell is a mobile application that tabulates your screen time and categories it as healthy or unhealthy. The lesser your screen time gets, the more
         ‘Detox’ points you earn and more discounts you get. They’ll also be used for donations for social causes. "
          imgUrl={digitWellImagePath}
          showKnowMore="true"
        />
        <ProjectCard
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-right"}
          animType2="flip-left"
          name="SafeHer"
          content="SafeHer provides the the safest route at a particular time based on the intuition or experience of women on a scale from 1-10.
        A SOS feature enabling direct contact to nearby police station incase of an emergency. Application of Clustering techniques of ML and
        leveraging Google Maps API ."
          imgUrl={safeHerImagePath}
          showKnowMore="true"
        />
        <ProjectCard2
          animType1={window.innerWidth <= 400 ? "fade-up" : "fade-left"}
          animType2="flip-left"
          name="StreetWise"
          content="StreetWise Addresses Common Problem of Traffic jams. Used IR Sensors to Detect Vehicle
        Density. Simulated Traffic Lights in accordance with Vehicle Density. Special Provisions for Emergencies , Like :- Ambulance."
          imgUrl={streetWiseImagePath}
          showKnowMore="true"
        />
      </div>
    </div>
  )
}

export default Project
